var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrders = function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#F8F9FA",
    rx: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    fillRule: "evenodd",
    d: "M40 20a2.857 2.857 0 0 1 2.857 2.857v4.286a2.857 2.857 0 0 1-5.714 0v-4.286A2.857 2.857 0 0 1 40 20",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    fillRule: "evenodd",
    d: "M40 24.234a17.143 17.143 0 0 0-17.143 17.143v10a1.43 1.43 0 0 0 1.429 1.429h31.428a1.43 1.43 0 0 0 1.429-1.429v-10A17.143 17.143 0 0 0 40 24.234",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "M56.923 50.717H23.077A3.076 3.076 0 0 0 20 53.794v3.077c0 1.7 1.377 3.078 3.077 3.078h33.846c1.7 0 3.077-1.378 3.077-3.078v-3.077c0-1.7-1.377-3.077-3.077-3.077"
  })));
};
export default SvgOrders;